import { makeCancellable, takeLatest } from "vuex-cancellable-actions";
import TelemeterJsonRepository from "../repository/json/TelemeterJsonRepository";
import Logger from "./../lib/logger";
import PageLog from "./../lib/pageLog.js";
import { RepositoryFactory } from "./../repository/RepositoryFactory";

const ObsSearchRepository = RepositoryFactory.get("obsSearch");
const SwinRepository = RepositoryFactory.get("swin");

export default {
  namespaced: true,
  state: {
    /** 観測所検索ダイアログ表示 */
    showSrchDlg: false,
    /** 観測所結果一覧 */
    rsltObsList: [],
    /** ヒット件数 */
    rsltObsCnt: 0,
    /** 検索状態 [1:検索前 2:検索中 3:検索後] */
    searchStatus: 1,
    /** 大量アクセス判定 */
    isAccessOver: false,
  },
  mutations: {
    /** 観測所検索ダイアログ表示切替 */
    setShowSrchDlg(state, data) {
      Logger.debug("[map]mut - setShowSrchDlg(" + data + ")");
      state.showSrchDlg = data;
    },
    /**
     * 観測所結果一覧をstateに設定
     * @param {*} state
     * @param {*} data
     */
    setRsltObsList(state, data) {
      Logger.debug("[search]mut - setRsltObsList(data)");
      Logger.dir(data);
      state.rsltObsList = data;
    },
    /**
     * 検索ヒット数ををstateに設定
     * @param {*} state
     * @param {*} data
     */
    setRsltObsCnt(state, data) {
      Logger.debug("[search]mut - setRsltObsCnt(" + data + ")");
      state.rsltObsCnt = data;
    },
    /**
     * 検索状態パラメータをstateに設定
     * @param {*} state
     * @param {*} data
     */
    setSearchStatus(state, data) {
      Logger.debug("[info]mut - setSearchStatus(" + data + ")");
      state.searchStatus = data;
    },
    /**
     * 検索状態パラメータをstateに設定
     * @param {*} state
     * @param {*} data
     */
    setIsAccessOver(state, data) {
      Logger.debug("[info]mut - setIsAccessOver(" + data + ")");
      state.isAccessOver = data;
    },
  },
  actions: makeCancellable({
    /**
     * 観測所検索結果一覧取得
     */
    getRsltObsList: takeLatest(async function(
      { commit },
      { keyword, targets, obsType, appTime, deviceSb, fcFlg }
    ) {
      Logger.debug(
        "[search]act - getRsltObsList(" +
          "keyword:" +
          keyword +
          ",targets:" +
          ",obsType:" +
          ")"
      );
      Logger.dir(targets);
      Logger.dir(obsType);
      Logger.debug(
        "[search]API - getRsltObsList(" +
          "keyword:" +
          keyword +
          ",targets:" +
          ",obsType:" +
          ")"
      );
      Logger.dir(targets);
      Logger.dir(obsType);
      // 検索状態を「検索中」にする
      commit("setSearchStatus", 2);
      // 大量アクセス判定を初期化する
      commit("setIsAccessOver", false);
      // APIからデータ取得
      const { data:data,error: rsltError } = await ObsSearchRepository.getRsltObsList(
        keyword,
        targets,
        obsType
      );
      Logger.debug("[search]API - getRsltObsList() - return");
      Logger.dir(data);
      // 大量アクセスだった場合の対応
      if(rsltError && rsltError.status == 503){
        commit("setIsAccessOver", true);
        commit("setRsltObsList", []);
        commit("setRsltObsCnt", 0);
        commit("setSearchStatus", 3);
      }
      const rsList = data.result.list;
      let list = [];
      for (const key in rsList) {
        const item = rsList[key];
        if (item.itmkndCd === "4") {
          let payload = {
            itmkndCd: item.itmkndCd,
            obsFcd: item.keyCd,
            appTime: appTime,
          };
          const {
            error,
            data: tmData,
          } = await TelemeterJsonRepository.getSelectedTm(payload);
          Logger.debug(
            "[search]API - getSelectedTm(itmkndCd:" +
              item.itmkndCd +
              "obsFcd:" +
              item.keyCd +
              "appTime:" +
              appTime +
              ") - return"
          );
          Logger.dir(tmData);
          const {
            stgError,
            data: stgData,
          } = await TelemeterJsonRepository.getSelectedObs(payload);
          Logger.debug(
            "[search]API - getSelectedObs(itmkndCd:" +
              item.itmkndCd +
              "obsFcd:" +
              item.keyCd +
              "appTime:" +
              appTime +
              ") - return"
          );
          Logger.dir(stgData);
          let listItem = {
            keyCd: item.keyCd,
            ofcCd: item.ofcCd,
            itmkndCd: item.itmkndCd,
            obsCd: item.obsCd,
            obsNm: item.obsNm,
            rvrNm: item.rvrNm,
            rsysNm: item.rsysNm,
            adr: item.adr,
            stgOvlvl: null,
            stgCcd: 160,
            rsrvStg: null,
            warnStg: null,
            spclWarnStg: null,
            dngStg: null,
          };
          if (!error && !stgError && tmData) {
            if (tmData.obsValue != null && tmData.obsValue != undefined) {
              if (Object.keys(tmData.obsValue).length) {
                listItem.stgOvlvl = tmData.obsValue.stgOvlvl;
                listItem.stgCcd = tmData.obsValue.stgCcd;
                listItem.rsrvStg = stgData.obsInfo.rsrvStg;
                listItem.warnStg = stgData.obsInfo.warnStg;
                listItem.spclWarnStg = stgData.obsInfo.spclWarnStg;
                listItem.dngStg = stgData.obsInfo.dngStg;
              }
            }
          }
          list.push(listItem);
        } else if (item.itmkndCd === "300") {
          let listItem = {
            keyCd: item.keyCd,
            ofcCd: item.ofcCd,
            itmkndCd: item.itmkndCd,
            obsCd: item.obsCd,
            obsNm: item.obsNm,
            rvrNm: item.rvrNm,
            rsysNm: item.rsysNm,
            adr: item.adr,
            swstgOvlvl: null,
            swstgCcd: 160,
          };
          const { error, data: swData } = await SwinRepository.getSelectedSwstg(
            item.obsCd,
            appTime
          );
          Logger.debug(
            "[search]API - getSelectedSwstg(obsCd:" +
              item.obsCd +
              "appTime:" +
              appTime +
              ") - return"
          );
          Logger.dir(swData);

          if (!error && swData) {
            if (swData.obsValue != null && swData.obsValue != undefined) {
              if (Object.keys(swData.obsValue).length > 0) {
                listItem.swstgOvlvl = swData.obsValue.swstgOvlvl;
                listItem.swstgCcd = 0;
              }
            }
          }
          list.push(listItem);
        } else {
          list.push(item);
        }
      }
      commit("setRsltObsList", list);
      commit("setRsltObsCnt", data.result.count);
      // 検索状態を「検索後」にする
      commit("setSearchStatus", 3);

      // アクセスログ出力
      // 該当なしフラグ設定
      let noHit = 0;
      if (data.result.count == 0) noHit = 1;
      PageLog.log({
        page_log: "mobsearch",
        device_sb: deviceSb,
        fc_flg: fcFlg,
        kw: keyword,
        no_hit: noHit,
      });
    }),
  }),
};
